import {airBlue, airBlueLight} from '@modifi/colors'
import styled from 'styled-components'

export const UserLogo = styled.div<{bgColor: string}>`
  display: inline-block;
  font-size: 1em;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  text-align: center;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 1em;
  background-color: ${({bgColor}): string => bgColor ?? airBlueLight};
`

export const UserInitials = styled.span<{textColor?: string}>`
  text-transform: uppercase;
  color: ${({textColor}): string => textColor ?? airBlue};
`
